module.exports = __webpack_public_path__ + "static/media/texts-failed-icon.efbf0816.svg";